import axios from 'axios';

const BELIEF_PROPERTY = 'belief';
const OPTION_PROPERTY = 'option';
const OPTION_COMPLEMENT_PROPERTY = 'optioncomplement';
const BELIEF_COMPLEMENT_PROPERTY = 'beliefcomplement';
const WIGO_PROPERTY = 'wigo';
const WIGO_BELIEF_PROPERTY = 'wigoBelief';
const LOGO_PROPERTY = 'logo';
const LOGO_BELIEF_PROPERTY = 'logoBelief';

export default {
  
  getBelieves (projectId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/beliefs`);
  },

  getAllConflictingBelieves (projectId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/beliefs/complements`);
  },

  optionProperty(beliefMode) {
    return beliefMode ? BELIEF_PROPERTY : OPTION_PROPERTY;
  },

  optioncomplementProperty(beliefMode) {
    return beliefMode ? BELIEF_COMPLEMENT_PROPERTY : OPTION_COMPLEMENT_PROPERTY;
  },

  wigoProperty(beliefMode) {
    return beliefMode ? WIGO_BELIEF_PROPERTY : WIGO_PROPERTY;
  },

  logoProperty(beliefMode) {
    return beliefMode ? LOGO_BELIEF_PROPERTY : LOGO_PROPERTY;
  },

}